import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-15d54b58")

_pushScopeId("data-v-15d54b58")
const _hoisted_1 = {
  action: "",
  autocomplete: "off"
}
const _hoisted_2 = { class: "divide-elements" }
const _hoisted_3 = { class: "element-first" }
const _hoisted_4 = { class: "data second alert-message" }
const _hoisted_5 = { class: "input-border first" }
const _hoisted_6 = /*#__PURE__*/_createVNode("label", { for: "title" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Interní název", -1)
const _hoisted_8 = { class: "group" }
const _hoisted_9 = { class: "border-gr short" }
const _hoisted_10 = { class: "end-form" }
const _hoisted_11 = { class: "list" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TheLanguage = _resolveComponent("TheLanguage")
  const _component_TheEvent = _resolveComponent("TheEvent")
  const _component_TheEventList = _resolveComponent("TheEventList")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("form", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_TheLanguage, {
            "selected-languages": _ctx.languages,
            name: "lang",
            title: "Jazyková mutace",
            onAddLanguage: _ctx.addNewPromoEvent
          }, null, 8, ["selected-languages", "onAddLanguage"])
        ])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _hoisted_7,
          _createVNode("div", _hoisted_8, [
            _createVNode("div", _hoisted_9, [
              _withDirectives(_createVNode("input", {
                type: "text",
                autocomplete: "nope",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.promoEventTitle = $event))
              }, null, 512), [
                [_vModelText, _ctx.promoEventTitle]
              ])
            ])
          ])
        ])
      ]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.promoEventTranslates, (promoEvent) => {
        return (_openBlock(), _createBlock(_component_TheEvent, {
          key: promoEvent,
          "promo-event": promoEvent,
          onSetImageUrl: _ctx.setImageContent,
          onSetPageContentImageUrl: _ctx.setPageContentImageUrl,
          onSetTitle: _ctx.setTitle,
          onSetDescription: _ctx.setDescription,
          onSetHowToWorks: _ctx.setHowToWorks,
          onSetDate: _ctx.setDate,
          onSetWeb: _ctx.setWeb
        }, null, 8, ["promo-event", "onSetImageUrl", "onSetPageContentImageUrl", "onSetTitle", "onSetDescription", "onSetHowToWorks", "onSetDate", "onSetWeb"]))
      }), 128)),
      _createVNode("div", _hoisted_10, [
        (_ctx.isRearranging)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              class: "convert",
              type: "button",
              onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.saveOrderedPromoEvents && _ctx.saveOrderedPromoEvents(...args)))
            }, "Save"))
          : _createCommentVNode("", true),
        (_ctx.isRearranging)
          ? (_openBlock(), _createBlock("button", {
              key: 1,
              class: "convert",
              type: "button",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.cancelRearrange && _ctx.cancelRearrange(...args)))
            }, "Cancel"))
          : _createCommentVNode("", true),
        (!_ctx.isRearranging)
          ? (_openBlock(), _createBlock("button", {
              key: 2,
              class: "convert",
              type: "button",
              onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.rearrangePromoEvents && _ctx.rearrangePromoEvents(...args)))
            }, "Rearrange"))
          : _createCommentVNode("", true),
        _createVNode("button", {
          class: "convert",
          type: "button",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.savePromoEvent && _ctx.savePromoEvent(...args)))
        }, "Zveřejnit")
      ])
    ]),
    _createVNode("div", _hoisted_11, [
      _createVNode(_component_TheEventList, {
        "promo-events": _ctx.getSortedArray,
        "is-rearranging": _ctx.isRearranging,
        onMovePromoEvent: _ctx.movePromoEvent,
        onRemovePromoEvent: _ctx.removePromoEvent,
        onStartLoading: _ctx.startLoading,
        onEditPromoEvent: _ctx.editPromoEvent,
        onInvokeError: _ctx.invokeError,
        onInvokeSuccess: _ctx.invokeSuccess
      }, null, 8, ["promo-events", "is-rearranging", "onMovePromoEvent", "onRemovePromoEvent", "onStartLoading", "onEditPromoEvent", "onInvokeError", "onInvokeSuccess"])
    ])
  ], 64))
})